import { Box, styled, Typography } from "@material-ui/core";
import { VerifiedUser } from "@material-ui/icons";
import {
  EPOCUS_PANEL_SCOPED_BORDER,
  EPOCUS_PANEL_SCOPED_HEADER_BG,
  EPOCUS_PRIMARY,
  EPOCUS_TEXT_PRIMARY,
  rem,
} from "../../_lib/epocus-palette";

const BannerRoot = styled(Box)({
  display: "flex",
  gap: 12,
  alignItems: "flex-start",
  backgroundColor: EPOCUS_PANEL_SCOPED_HEADER_BG,
  border: `1px solid ${EPOCUS_PANEL_SCOPED_BORDER}`,
  borderRadius: 12,
  padding: "12px 14px",
});

export const BillingBanner: FCwC = ({ children }) => (
  <BannerRoot>
    <VerifiedUser style={{ color: EPOCUS_PRIMARY, fontSize: rem(20) }} />
    <Typography
      style={{ fontSize: rem(13), color: EPOCUS_TEXT_PRIMARY, lineHeight: 1.5 }}
    >
      {children}
    </Typography>
  </BannerRoot>
);
